import { formatTime, formatDate } from '../../filter'
import moment from 'moment'

// 约定的数据字段结构
/**
 * 获取编辑数据
 * @returns {
    key: string; // 字段名称
    label: string; // 字段显示名
    value: string; // 字段当前值。枚举值时用英文逗号分隔。已经设值和默认值都可通过当前字段实现。当字段类型为下拉列表等时，要映射到枚举值的展示值
    type: string; // 字段类型
    notNull: string; // 是否必填。0-非必填，1-必填
    enumCode: string; // enumCode":"对应枚举code。当type为下拉列表/选框时用
    length?: number; // 字段长度限制。当type为文本输入框时用
    maxValue?: number; // 最大值。type为数字时用
    minValue?: number; // 最小值。type为数字时用
    canEdit?: boolean; // 自定义的是否可编辑
    selectOption: any[]; // 自定义的下拉选项
    rules?: any[]; // 支持自定义校验规则
    spacialLabelWidth?: number; // 支持自定义label宽度
    symbol?: string; // 输入框后面的单位或符号
    button?: string; // 输入框后面的按钮
    btnFun?: Function; // 输入框后面的按钮
    labelSpan?: Function; // label的栅格比例
    wrapperSpan?: Function; // 内容的栅格比例
	formSpan?: number; // 表单的栅格比例
}
 */

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this

	const injuredInfo = (injured && injured.injuredInfo) || {}

	const modal = [
		{
			label: '诊断名称',
			value: '',
			key: 'clinicalDiagnosis',
			selectOption: [],
			type: 'searchSelect',
			notNull: '1',
			canEdit: true,
			formSpan: 4,
		},
		{
			label: '损伤部位I',
			value: '',
			key: 'injuredPartOne',
			type: 'text',
			notNull: '0',
			canEdit: false,
			formSpan: 3,
		},
		{
			label: '损伤分类',
			value: '',
			key: 'injuredSort',
			selectOption: [],
			type: 'select',
			notNull: '1',
			canEdit: true,
			formSpan: 4,
		},
		{
			label: '手术名称',
			value: [],
			key: 'operationDesc',
			selectOption: [],
			type: 'select',
			notNull: '1',
			canEdit: true,
			formSpan: 4,
			mode: 'multiple',
		},
		{
			label: '骨折类型',
			value: '',
			key: 'fractureType',
			selectOption: setting.fracturetypeList,
			type: 'select',
			notNull: '1',
			canEdit: true,
			formSpan: 3,
		},
		{
			label: '后续治疗项目',
			value: [],
			key: 'followTreatmentDesc',
			selectOption: [],
			type: 'select',
			notNull: '1',
			canEdit: true,
			formSpan: 3,
			mode: 'multiple',
		},
	]

	const list =
		injuredInfo.diagnoseList &&
		injuredInfo.diagnoseList.map((item, index) => {
			const valArr = [
				item.clinicalDiagnosis,
				item.injuredPartOne,
				item.injuredSort,
				item.operationDesc,
				item.fractureType,
				item.followTreatmentDesc,
			]

			let arr = modal.map((moadlItem, valIndex) => {
				let obj = {
					...moadlItem,
					value: valArr[valIndex],
				}
				// 组装诊断名称列表数据
				if (obj.key == 'clinicalDiagnosis') {
					obj.selectOption = [
						{
							key: item.clinicalDiagnosis,
							value: item.clinicalDiagnosis,
						},
					]
				}
				// 组装损伤分类列表数据
				if (obj.key == 'injuredSort') {
					obj.value = item.diagnosisCode
					obj.selectOption = [
						{
							key: item.diagnosisCode,
							value: item.injuredSort,
						},
					]
				}
				// 组装手术列表数据
				if (obj.key == 'operationDesc') {
					if (item.operationList && item.operationList.length) {
						obj.value = []
						obj.selectOption = []
						for (const iterator of item.operationList) {
							obj.value.push(iterator.operationCode + '-')
							obj.selectOption.push({
								key: iterator.operationCode + '-',
								value: iterator.operationName,
							})
						}
					}
				}
				// 组装后续治疗列表数据
				if (obj.key == 'followTreatmentDesc') {
					if (item.followTreatmentList && item.followTreatmentList.length) {
						// console.log(item.followTreatmentList, 'followTreatmentList')
						// obj.value = item.followTreatmentList[0].operationCode
						// obj.selectOption = [
						// 	{
						// 		key: item.followTreatmentList[0].operationCode,
						// 		value: item.followTreatmentList[0].cuteItem,
						// 	},
						// ]
						obj.value = []
						obj.selectOption = []
						for (const iterator of item.followTreatmentList) {
							obj.value.push(iterator.operationCode)
							obj.selectOption.push({
								key: iterator.operationCode,
								value: iterator.cuteItem,
							})
						}
					} else {
						obj.notNull = '0'
						obj.canEdit = false
					}
				}

				return obj
			})

			return {
				list: arr,
			}
		})

	const obj = {
		title: '诊断库:',
		key: 'injuredInfo.diagnoseList', // 提交时对应的字段
		modal: modal, // 每一行的模板
		children: list, // 数据列表
	}

	return obj
}
